import React, {useEffect, useMemo, useRef, useState} from "react";
import Datatable from "components/Core/DataTable";
import {
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Row,
	Col, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button, ModalFooter, Modal
} from "reactstrap";
import Notify from "../lib/Utils/Alert";
import {MotionButton} from "../components/Core/MotionStrap";
import NotificationAlert from "react-notification-alert";
import Category from "../lib/Core/Backend/Controllers/Category";
import Brand from "../lib/Core/Backend/Controllers/Brand";
import FormValidator from "../lib/Utils/FormValidator";
import $ from "jquery"
import Spinner from 'react-bootstrap/Spinner';

import ConfirmationAlertTwo from "components/ConfirmationAlert/ConfirmationAlertTwo";
function CategoryView(props)
{
	const {token} = props;
	const categoryCtl = useMemo(() => new Category(token),[token]);
	const brandCtl = useMemo(() => new Brand(token),[token]);
	const [modal, setModal] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);
	const [modalConfirmation, setModalConfirmation] = useState(false);
	const [warningModal,setWarningModal] = useState(false)
	const [categoryToEdit, setCategoryToEdit] = useState('');
	const toggle = () => setModal(!modal);
	const toggleConfirm = () => setConfirmModal(!confirmModal);
	const toggleWarning = () => setWarningModal(!warningModal)

	const [activeOp, setActiveOp] = useState("Add New");
	const [activeOpText, setActiveOpText] = useState("Please provide the name of the category you want to add.");
	const [operativeRow, setOperativeRow] = useState({});
	const [categoryCreateLoading, setCategoryCreateLoading] = useState(false);
	const [deleteCategoryloading, setDeleteCategoryLoading] = useState(false);
	const [loader,setLoader] = useState(true)

	const newCategory = useRef();
	const form = useRef();
	const table = useRef();
	const alert = useRef();

	const header = [
		{title: 'Name', data: 'name', sortable: true, searchable: true, render: $.fn.dataTable.render.text(),
			renderForSelect: data => ({label: data, value: data})
		},
		{
			title: 'Brand in Category', data: 'brands.count', sortable: true, searchable: false, defaultValue: 0,
			render: (data, type) =>
			{
				let toShow;
				if (data)
					toShow = parseInt(data);
				else
					toShow = 0;

				if (type === "display")
					return `${toShow} ${toShow === 1 ? "Brand" : "Brands"}`;

				return toShow;
			}
		}
	];

	function onRowCreated(row)
	{
		if (table.current)
		{
			row.classList.add("ncentiva-datatable-row");
			row.addEventListener('click', () =>
			{
				const thisRow = table.current.dataTable.row(row);
				if (thisRow.child.isShown())
				{
					thisRow.child.hide();
				} else
				{
					thisRow.child.show();
				}
			});
		}
	}

	function onDraw()
	{
		if (table.current)
		{
			table.current.dataTable.rows().eq(0).each((i) =>
				{
					const row = table.current.dataTable.row(i);
					const rowData = row.data();
					if (rowData && rowData.brands && rowData.brands.result)
					{
						let child = "";
						let id = `tooltip-trigger-${Date.now()}`;
						rowData.brands.result.forEach(item => child +=
							`<div class="ncentiva-small-info-block">
								<div class="logo" style="background-image: url('${brandCtl.logo(item.name)}');"></div>
								<div class="brandName" id="${id}" data-toggle="tooltip" data-placement="bottom" title="${item.name}">${item.name}</div>
							</div>`)
						row.child(child).hide();
						row.child().addClass("ncentiva-datatable-child-row");
					}
				}
			)
		}
	}

	function prepareToAdd()
	{
		toggle();
		setActiveOp("Add New");
		setActiveOpText("Please provide the name of the category you want to add.");
		if (form.current)
			form.current.name.value = ""
	}

	function prepareToEdit(row)
	{
		toggle();
		setActiveOp("Edit");
		setActiveOpText("Edit the name of the category.");
		setOperativeRow(row);
		setCategoryToEdit(row.data().name)
		if (form.current)
			form.current.name.value = row.data().name;
	}

	function createCategoryLoading(){
		setTimeout(() => {
			setCategoryCreateLoading(false);
		}, 1500);
	}
	function finishOperation(e)
	{
		setCategoryCreateLoading(true);
		e.preventDefault();
		e.stopPropagation();

		const fv = new FormValidator(form.current, (type, message) => Notify(alert, type, message),
			[
				{label: "Category Name", property: "name", required: true}
			]
		);

		if (!fv.isFormValid()) {
			setCategoryCreateLoading(false);
			return;
		}

		const categoryInfo = fv.getDTO();

		switch (activeOp)
		{
			case "Add New":
				const allowedSpecialCharactersRegex = /^[a-zA-Z0-9&,_\s-]+$/;
				if (!allowedSpecialCharactersRegex.test(categoryInfo.name)) {
					createCategoryLoading()
				Notify(alert, "danger", "Category Name can only contain alphanumeric characters, '&', ',', '-', and '_'.");
				  } else {
				categoryCtl.add(categoryInfo.name, data =>
				{
					if(data?.status === 403){
						toggleWarning();
						createCategoryLoading()
						toggle();
						return;
					}

					if (data.errorMessage || data.error)
					{
						Notify(alert, "danger", data.errorMessage ?? data.error);
						createCategoryLoading()
					} else
					{
						Notify(alert,"success","New Category Added")
						table.current.dataTable.row.add(data).draw();
						createCategoryLoading()
						toggle();
					}
					
				});
			}
				break;
			case "Edit":
				categoryCtl.update(operativeRow.data().id, categoryInfo.name, data =>
				{
					if(data?.status === 403){
						toggleWarning();
						createCategoryLoading()
						toggle();
						return;
					}

					if (data.errorMessage || data.error)
					{
						Notify(alert, "danger", data.errorMessage ?? data.error);
						createCategoryLoading()
					} else
					{
						Notify(alert,"success","Update category successfully")
						operativeRow.data(data).draw();
						toggle();
						createCategoryLoading()
					}
					
				});
				break;
			default:
		}
	}

	function removeCategory(row)
	{
		setOperativeRow(row);
		toggleConfirm();
	}

	function deleteCatLoading(){
		setTimeout(() => {
			setDeleteCategoryLoading(false);
		}, 1500);
	}
	function confirmDelete()
	{
		setDeleteCategoryLoading(true);
		categoryCtl.remove(operativeRow.data().id, data =>
		{
          if(data?.status === 403){
				deleteCatLoading()
				toggleWarning();
				toggleConfirm();
				return;
			}

			if (!data || data.error)
			{
				if (data.status === 500){
					Notify(alert, "danger", "You cannot remove a Category that has Brand associated with it.");
					deleteCatLoading()
				}
				else{
					Notify(alert, "danger", data.error);
					deleteCatLoading()
				}
			} else
			{
				const row = operativeRow;
				setOperativeRow(null);
				row.remove().draw();
				deleteCatLoading()
			}
			toggleConfirm();
		});
	}

	function confirmLeave () {
		const categoryInfo = newCategory.current.value
		if ((activeOp === 'Add New' && categoryInfo.length > 0) ||
			(activeOp === 'Edit' && categoryToEdit !== categoryInfo)) {
			setModalConfirmation(true)
		} else {
			toggle()
		}
	}

	function closeModalConfirmation () {
		setModalConfirmation(false)
	}

	function closeAllModals() {
		setModalConfirmation(false)
		toggle()
	}

	function setCategories(data)
	{
	
			setLoader(false)
	
		
		if (table.current)
			table.current.dataTable.clear().rows.add(data).draw();
	}

	useEffect(() =>
	{
		categoryCtl.all(setCategories);
	},[]);

	return (<>
			<NotificationAlert ref={alert}/>
			<div className="content">
				<Row>
					<Col md="12">
						<Card>
						<CardHeader className="d-flex justify-content-between">
								<CardTitle tag="h4">Ncentiva Platform Brand Category List</CardTitle>
								<Row className="justify-content-end">
									<Col md="12" className="align-content text-right">
										<MotionButton initial={{ x: "-500%", opacity: 0 }} className="create_purchase btn btn-primaryTwo"
											style={{width:'190px',minWidth:'auto'}} animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }}  onClick={prepareToAdd}>
											<i className="fas fa-folder-open" />{' '}Add new category
										</MotionButton>
									</Col>
								</Row>
							</CardHeader>
							<CardBody>
							{loader ? 
								<div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
							:
								<div className="data_table">
								<Datatable ref={table} columns={header} data={null} options={{
									createdRow: onRowCreated,
									drawCallback: onDraw,
									dom: 'tip',
								}} addRemoveButton={{callback: removeCategory}} addEditButton={{callback: prepareToEdit}}
									enableSelectFilters={true}
								/>
								</div>
                                }
							</CardBody>
						</Card>
					</Col>
				</Row>
				<Modal isOpen={modal} toggle={toggle} backdrop="static" centered={true} size="sm">
					<ModalHeader toggle={toggle} className="custom_header_colourTwo">{activeOp} Category</ModalHeader>
					<Form innerRef={form}>
						<ModalBody>
							<p className="card-just-text">
								{activeOpText}
							</p>
							<Row form>
								<Col md={12}>
									<FormGroup>
										<Label for="name">Category</Label>
										<Input id="name" name="name" innerRef={newCategory} type="text" maxLength="70" placeholder="Name of the new category"/>
									</FormGroup>
								</Col>
							</Row>
						</ModalBody>
						<ModalFooter>
							<Button type="button" color="secondary" onClick={confirmLeave}>Cancel</Button>{' '}
						<Button type="submit" className="btn btn-primaryTwo" onClick={categoryCreateLoading ? undefined : finishOperation} disabled={categoryCreateLoading}>{!categoryCreateLoading && "Save"}
							{categoryCreateLoading && <Spinner
								as="span"
								animation="border"
								size="sm"
								role="status"
								aria-hidden="true"
								style={{
									margin: "0px 8px"
								}}
							/>}</Button>
						</ModalFooter>
					</Form>
				</Modal>
				<Modal isOpen={confirmModal} toggle={toggleConfirm} backdrop="static">
					<ModalHeader className="custom_header_colourTwo" toggle={toggleConfirm}>Remove Category</ModalHeader>
					<ModalBody>
						<p className="card-just-text">
							Are you sure you want to remove the category "{(operativeRow !== null && !!operativeRow && !!operativeRow.data) ? operativeRow.data().name : ""}"?
						</p>
					</ModalBody>
					<ModalFooter>
						<Button type="button" color="secondary" onClick={toggleConfirm}>Cancel</Button>{' '}
						<Button type="button" className="btn btn-primaryTwo" onClick={confirmDelete} disabled={deleteCategoryloading}>{!deleteCategoryloading && "Yes"}{
							deleteCategoryloading && <Spinner
								as="span"
								animation="border"
								size="sm"
								role="status"
								aria-hidden="true"
								style={{
									margin: "0px 8px"
								}}
							/>}
						</Button>
					</ModalFooter>
				</Modal>
				<Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
         </Modal>
				<ConfirmationAlertTwo stayModal={closeModalConfirmation} openModal={modalConfirmation} leaveModal={closeAllModals} />
			</div>
		</>
	);
}

export default CategoryView;
